import React from 'react';

export const ContentSurveysCloseAccess = () => {
  return (
    <svg
      width="90"
      height="97"
      viewBox="0 0 90 97"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_11310_29002)">
        <circle
          cx="28.0665"
          cy="28.0665"
          r="28.0665"
          transform="matrix(0.95738 0.288831 -0.280968 0.959717 23.293 20.5863)"
          fill="#E2E6EB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.5597 22.3327L38.4366 29.5849C37.8144 31.71 35.5914 32.9144 33.4714 32.2748C31.3514 31.6352 30.1372 29.3939 30.7594 27.2687L32.8825 20.0165C35.6003 10.7333 45.394 5.49768 54.7574 8.32251C64.1208 11.1473 69.5081 20.9629 66.7903 30.2461L64.6671 37.4983C64.045 39.6235 61.822 40.8278 59.702 40.1882C57.582 39.5487 56.3677 37.3074 56.9899 35.1822L59.1131 27.93C60.6001 22.8505 57.6524 17.4797 52.529 15.9341C47.4057 14.3884 42.0468 17.2531 40.5597 22.3327Z"
          fill="#85AAF2"
        />
        <g filter="url(#filter1_iiii_11310_29002)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.4395 22.2095L37.2803 29.5849C36.6582 31.71 34.4352 32.9144 32.3152 32.2748C30.1952 31.6352 28.9809 29.3939 29.6031 27.2687L31.7623 19.8934C34.5102 10.5072 44.3284 5.18811 53.6918 8.01294C63.0551 10.8378 68.418 20.7368 65.6701 30.123L63.5109 37.4983C62.8887 39.6235 60.6657 40.8278 58.5457 40.1882C56.4257 39.5487 55.2115 37.3074 55.8336 35.1822L57.9929 27.8069C59.4964 22.671 56.562 17.2546 51.4387 15.7089C46.3153 14.1633 40.9431 17.0737 39.4395 22.2095Z"
            fill="#99BCFF"
          />
        </g>
        <g filter="url(#filter2_i_11310_29002)">
          <circle
            cx="28.0665"
            cy="28.0665"
            r="28.0665"
            transform="matrix(0.95738 0.288831 -0.280968 0.959717 21.1367 20.5277)"
            fill="url(#paint0_linear_11310_29002)"
          />
          <circle
            cx="28.0665"
            cy="28.0665"
            r="28.0665"
            transform="matrix(0.95738 0.288831 -0.280968 0.959717 21.1367 20.5277)"
            fill="url(#paint1_linear_11310_29002)"
            fillOpacity="0.4"
          />
        </g>
        <circle
          cx="28.0665"
          cy="28.0665"
          r="27.3983"
          transform="matrix(0.95738 0.288831 -0.280968 0.959717 21.1367 20.5277)"
          stroke="url(#paint2_linear_11310_29002)"
          strokeWidth="1.3365"
        />
        <circle
          cx="18.711"
          cy="18.711"
          r="18.711"
          transform="matrix(0.95738 0.288831 -0.280968 0.959717 28.125 32.2963)"
          fill="#85AAF2"
        />
        <g filter="url(#filter3_d_11310_29002)">
          <circle
            cx="18.711"
            cy="18.711"
            r="18.711"
            transform="matrix(0.95738 0.288831 -0.280968 0.959717 27.4648 32.2073)"
            fill="#99BCFF"
          />
        </g>
        <g filter="url(#filter4_i_11310_29002)">
          <circle
            cx="11.3603"
            cy="11.3603"
            r="11.3603"
            transform="matrix(0.95738 0.288831 -0.280968 0.959717 32.4336 41.3856)"
            fill="url(#paint3_linear_11310_29002)"
          />
          <circle
            cx="11.3603"
            cy="11.3603"
            r="11.3603"
            transform="matrix(0.95738 0.288831 -0.280968 0.959717 32.4336 41.3856)"
            fill="white"
            fillOpacity="0.2"
          />
        </g>
        <g filter="url(#filter5_i_11310_29002)">
          <path
            d="M36.5532 67.7517C36.9065 67.8583 37.1095 68.2322 37.0058 68.5864L36.0666 71.7924C35.9629 72.1465 35.5926 72.3476 35.2393 72.2411C34.886 72.1345 34.684 71.7607 34.7877 71.4065L35.7259 68.2004C35.8296 67.8463 36.1999 67.6453 36.5532 67.7517ZM46.1933 66.7756C46.5165 66.6005 46.9209 66.7208 47.0959 67.0439L48.699 70.0033C48.874 70.3265 48.7538 70.7308 48.4306 70.9059C48.1076 71.0808 47.7041 70.9606 47.529 70.6377L45.925 67.6782C45.7499 67.355 45.8701 66.9507 46.1933 66.7756ZM28.0929 61.3194C28.4186 61.1431 28.8256 61.2641 29.0021 61.5896C29.1786 61.9154 29.0576 62.3233 28.7318 62.4999L25.816 64.0793C25.4902 64.2558 25.0823 64.1347 24.9058 63.8089C24.7295 63.4833 24.8506 63.0763 25.176 62.8996L28.0929 61.3194ZM53.1052 58.787L56.3038 59.7518C56.6571 59.8583 56.8591 60.2321 56.7554 60.5863C56.6517 60.9404 56.2815 61.1415 55.9282 61.035L52.7297 60.0692C52.3765 59.9626 52.1736 59.5896 52.277 59.2355C52.3807 58.8813 52.7519 58.6804 53.1052 58.787ZM24.3157 50.0996L27.5143 51.0644C27.8676 51.171 28.0696 51.5447 27.9659 51.8989C27.8621 52.2529 27.4919 52.4541 27.1387 52.3476L23.9402 51.3818C23.5871 51.2753 23.3841 50.9022 23.4875 50.5481C23.5912 50.1939 23.9624 49.993 24.3157 50.0996ZM54.4242 47.0528C54.75 46.8763 55.1579 46.9974 55.3345 47.3232C55.511 47.649 55.3899 48.0568 55.0641 48.2334L52.1474 49.8127C51.8216 49.9891 51.4146 49.8682 51.2382 49.5424C51.0617 49.2167 51.1827 48.8097 51.5084 48.6332L54.4242 47.0528ZM31.8115 40.2274C32.1346 40.0526 32.5381 40.1726 32.7131 40.4956L34.3162 43.4549C34.4912 43.7781 34.371 44.1825 34.0478 44.3576C33.7248 44.5322 33.3212 44.4122 33.1461 44.0894L31.5431 41.13C31.368 40.8068 31.4883 40.4024 31.8115 40.2274ZM45.0019 38.8911C45.3551 38.9978 45.5572 39.3716 45.4535 39.7256L44.5152 42.9328C44.4114 43.2868 44.0404 43.4869 43.6871 43.3803C43.334 43.2737 43.1319 42.9008 43.2353 42.5468L44.1737 39.3397C44.2774 38.9855 44.6486 38.7845 45.0019 38.8911Z"
            fill="url(#paint4_linear_11310_29002)"
          />
          <path
            d="M36.5532 67.7517C36.9065 67.8583 37.1095 68.2322 37.0058 68.5864L36.0666 71.7924C35.9629 72.1465 35.5926 72.3476 35.2393 72.2411C34.886 72.1345 34.684 71.7607 34.7877 71.4065L35.7259 68.2004C35.8296 67.8463 36.1999 67.6453 36.5532 67.7517ZM46.1933 66.7756C46.5165 66.6005 46.9209 66.7208 47.0959 67.0439L48.699 70.0033C48.874 70.3265 48.7538 70.7308 48.4306 70.9059C48.1076 71.0808 47.7041 70.9606 47.529 70.6377L45.925 67.6782C45.7499 67.355 45.8701 66.9507 46.1933 66.7756ZM28.0929 61.3194C28.4186 61.1431 28.8256 61.2641 29.0021 61.5896C29.1786 61.9154 29.0576 62.3233 28.7318 62.4999L25.816 64.0793C25.4902 64.2558 25.0823 64.1347 24.9058 63.8089C24.7295 63.4833 24.8506 63.0763 25.176 62.8996L28.0929 61.3194ZM53.1052 58.787L56.3038 59.7518C56.6571 59.8583 56.8591 60.2321 56.7554 60.5863C56.6517 60.9404 56.2815 61.1415 55.9282 61.035L52.7297 60.0692C52.3765 59.9626 52.1736 59.5896 52.277 59.2355C52.3807 58.8813 52.7519 58.6804 53.1052 58.787ZM24.3157 50.0996L27.5143 51.0644C27.8676 51.171 28.0696 51.5447 27.9659 51.8989C27.8621 52.2529 27.4919 52.4541 27.1387 52.3476L23.9402 51.3818C23.5871 51.2753 23.3841 50.9022 23.4875 50.5481C23.5912 50.1939 23.9624 49.993 24.3157 50.0996ZM54.4242 47.0528C54.75 46.8763 55.1579 46.9974 55.3345 47.3232C55.511 47.649 55.3899 48.0568 55.0641 48.2334L52.1474 49.8127C51.8216 49.9891 51.4146 49.8682 51.2382 49.5424C51.0617 49.2167 51.1827 48.8097 51.5084 48.6332L54.4242 47.0528ZM31.8115 40.2274C32.1346 40.0526 32.5381 40.1726 32.7131 40.4956L34.3162 43.4549C34.4912 43.7781 34.371 44.1825 34.0478 44.3576C33.7248 44.5322 33.3212 44.4122 33.1461 44.0894L31.5431 41.13C31.368 40.8068 31.4883 40.4024 31.8115 40.2274ZM45.0019 38.8911C45.3551 38.9978 45.5572 39.3716 45.4535 39.7256L44.5152 42.9328C44.4114 43.2868 44.0404 43.4869 43.6871 43.3803C43.334 43.2737 43.1319 42.9008 43.2353 42.5468L44.1737 39.3397C44.2774 38.9855 44.6486 38.7845 45.0019 38.8911Z"
            fill="white"
            fillOpacity="0.2"
          />
        </g>
      </g>
      <rect
        x="15.3828"
        y="25.6138"
        width="7.5307"
        height="2.13405"
        rx="1.06703"
        transform="rotate(-132.756 15.3828 25.6138)"
        fill="#99BCFF"
      />
      <rect
        x="9.06641"
        y="34.4308"
        width="7.5307"
        height="2.13405"
        rx="1.06703"
        transform="rotate(-176.933 9.06641 34.4308)"
        fill="#99BCFF"
      />
      <rect
        x="24.0117"
        y="19.2549"
        width="7.5307"
        height="2.13405"
        rx="1.06703"
        transform="rotate(-106.855 24.0117 19.2549)"
        fill="#99BCFF"
      />
      <rect
        x="74.5898"
        y="28.9724"
        width="7.5307"
        height="2.13405"
        rx="1.06703"
        transform="rotate(-27.1629 74.5898 28.9724)"
        fill="#99BCFF"
      />
      <rect
        x="75.1016"
        y="39.7208"
        width="7.5307"
        height="2.13405"
        rx="1.06703"
        transform="rotate(8.73951 75.1016 39.7208)"
        fill="#99BCFF"
      />
      <rect
        x="74.8008"
        y="47.974"
        width="7.5307"
        height="2.13405"
        rx="1.06703"
        transform="rotate(39.4697 74.8008 47.974)"
        fill="#99BCFF"
      />
      <defs>
        <filter
          id="filter0_dd_11310_29002"
          x="8.47203"
          y="5.42189"
          width="71.5148"
          height="91.1126"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.68868" dy="1.3867" />
          <feGaussianBlur stdDeviation="1.61006" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.305882 0 0 0 0 0.301961 0 0 0 0 0.364706 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11310_29002"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3.03019" dy="6.10146" />
          <feGaussianBlur stdDeviation="3.33377" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.305882 0 0 0 0 0.301961 0 0 0 0 0.364706 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_11310_29002"
            result="effect2_dropShadow_11310_29002"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_11310_29002"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_iiii_11310_29002"
          x="27.4367"
          y="5.91881"
          width="41.627"
          height="37.114"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2.673" dy="2.00475" />
          <feGaussianBlur stdDeviation="1.3365" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.65 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_11310_29002"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1.3365" dy="2.673" />
          <feGaussianBlur stdDeviation="1.3365" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.521569 0 0 0 0 0.666667 0 0 0 0 0.94902 0 0 0 0.7 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_11310_29002"
            result="effect2_innerShadow_11310_29002"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-2.00475" dy="-1.3365" />
          <feGaussianBlur stdDeviation="1.00238" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.521569 0 0 0 0 0.666667 0 0 0 0 0.94902 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_11310_29002"
            result="effect3_innerShadow_11310_29002"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-0.66825" dy="-0.66825" />
          <feGaussianBlur stdDeviation="0.66825" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.521569 0 0 0 0 0.666667 0 0 0 0 0.94902 0 0 0 0.8 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_innerShadow_11310_29002"
            result="effect4_innerShadow_11310_29002"
          />
        </filter>
        <filter
          id="filter2_i_11310_29002"
          x="12.1094"
          y="27.4333"
          width="58.6918"
          height="59.8313"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2.66833" dy="5.33667" />
          <feGaussianBlur stdDeviation="1.77889" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.886275 0 0 0 0 0.901961 0 0 0 0 0.921569 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_11310_29002"
          />
        </filter>
        <filter
          id="filter3_d_11310_29002"
          x="19.4965"
          y="35.7089"
          width="46.1646"
          height="46.3326"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2.4558" dy="3.30637" />
          <feGaussianBlur stdDeviation="2.20425" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.521569 0 0 0 0 0.666667 0 0 0 0 0.94902 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_11310_29002"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_11310_29002"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_i_11310_29002"
          x="28.7812"
          y="44.1808"
          width="22.6758"
          height="24.9816"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.20425" />
          <feGaussianBlur stdDeviation="2.20425" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_11310_29002"
          />
        </filter>
        <filter
          id="filter5_i_11310_29002"
          x="23.4609"
          y="38.8625"
          width="33.3203"
          height="34.7435"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.3365" />
          <feGaussianBlur stdDeviation="0.66825" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_11310_29002"
          />
        </filter>
        <linearGradient
          id="paint0_linear_11310_29002"
          x1="0"
          y1="0"
          x2="45.2079"
          y2="69.0978"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F3F3F4" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11310_29002"
          x1="6.48088"
          y1="1.621"
          x2="51.3432"
          y2="50.659"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_11310_29002"
          x1="-3.4963"
          y1="-18.824"
          x2="43.9112"
          y2="98.252"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.8" />
          <stop offset="1" stopColor="white" stopOpacity="0.1" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_11310_29002"
          x1="-0.237731"
          y1="0.919364"
          x2="-0.0513312"
          y2="20.4494"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7FBFF" />
          <stop offset="1" stopColor="#E2E6EB" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_11310_29002"
          x1="34.5044"
          y1="37.426"
          x2="25.886"
          y2="61.9963"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7FBFF" />
          <stop offset="1" stopColor="#E2E6EB" />
        </linearGradient>
      </defs>
    </svg>
  );
};
